const posture = [{
  value: 'Lying',
  label: 'Lying'
},{
  value: 'Sitting',
  label: 'Sitting'
},{
  value: 'Kneeling',
  label: 'Kneeling'
},{
  value: 'Standing',
  label: 'Standing'
}]

  export {posture}